import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// 导入语言资源文件
import translationEN from './en.json'
import translationZHCN from './zhCN.json'

export const languageList = [
    {
        value: 'en',
        label: 'English',
    },
    {
        value: 'zh',
        label: '简体中文',
    },
]

const urlParams = new URLSearchParams(window.location.search)
const lang = urlParams.get('lang')
const langs = ['en', 'zh']
const localLang = window.localStorage.getItem('lang')
const currentLang = lang ? lang : localLang ? localLang : 'en'
// 创建 i18next 实例
i18n.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources: {
            en: { translation: translationEN },
            zh: { translation: translationZHCN },
        },
        lng: langs.includes(currentLang) ? currentLang : 'en', ///动态改语言
        fallbackLng: 'en', // 如果没有加载语言的资源则使用此语言
        interpolation: { escapeValue: false }, // React 已经安全地对值进行编码
    })

export default i18n
